var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 192","height":"192","width":"192","fill":"currentColor"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"96","cy":"153","r":"96","transform":"translate(0 -57)","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }